module.exports = __webpack_public_path__ + "img/slide1.0617b804.jpg";